export const APP_NAME = "Procurtal";
